import { hexToRgb, setStyle, createElement, addEventListener } from './utils';
import { AnalyticsMarketingCardFormConfig } from './index';
import { MarketingCardService } from './base';
import { AnalyticsCardCssString } from './AnalyticsStyle';
const ANALYTICS_CARD_STYLE_ID = 'AnalyticsCardStyle';
const appendStyle = () => {
    if (!document.getElementById(ANALYTICS_CARD_STYLE_ID)) {
        const style = document.createElement('style');
        style.id = ANALYTICS_CARD_STYLE_ID;
        style.textContent = AnalyticsCardCssString;
        document.head.appendChild(style);
    }
};
const removeStyle = () => {
    const style = document.getElementById(ANALYTICS_CARD_STYLE_ID);
    if (style) {
        document.head.removeChild(style);
    }
};
export class AnalyticsMarketingCardService extends MarketingCardService {
    constructor(params) {
        super(params);
        this.formConfig = AnalyticsMarketingCardFormConfig;
    }
    getStyle(isHovered) {
        const { color } = this._originCard;
        if (!color)
            return;
        return isHovered ? {
            border: `2px solid ${color}`,
            background: `linear-gradient(0deg, ${hexToRgb(color, 0.05)} 0%,${hexToRgb(color, 0.05)} 100%), #FFF`,
        } : {};
    }
    dispose() {
        removeStyle();
        this.el = undefined;
        this.disposes.forEach((dispose) => dispose());
    }
    render() {
        appendStyle();
        // 创建元素
        const containerDiv = createElement('div');
        const titleP = createElement('p');
        const imageDiv = createElement('div');
        const descP = createElement('p');
        const buttonDiv = createElement('div');
        const titleSpan = createElement('span');
        const descSpan = createElement('span');
        const buttonSpan = createElement('span');
        const svgNamespace = "http://www.w3.org/2000/svg";
        const buttonSvg = document.createElementNS(svgNamespace, 'svg');
        // 设置类名
        containerDiv.className = 'pt-analytics-card';
        titleP.className = 'pt-analytics-card__title';
        imageDiv.className = 'pt-analytics-card__img';
        descP.className = 'pt-analytics-card__desc';
        buttonDiv.className = 'pt-analytics-card__btn';
        buttonSpan.className = 'pt-analytics-card__btn-label';
        // 设置内容
        titleSpan.textContent = this.card.title;
        descSpan.textContent = this.card.desc;
        buttonSpan.textContent = this.card.button;
        buttonSvg.setAttribute('width', '24');
        buttonSvg.setAttribute('height', '24');
        const svgStr = '<svg width="24" height="24" fill="#fff" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path d="M13 17.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 1.414-1.414L11 17.586V4a1 1 0 0 1 2 0v13.586z" id="solid-arrow-tail-right"/></defs><use transform="matrix(0 1 1 0 0 0)" xlink:href="#solid-arrow-tail-right" fill-rule="evenodd"/></svg>';
        buttonSvg.innerHTML = svgStr;
        // 设置样式
        setStyle(imageDiv, { backgroundImage: `url(${this.card.img})` });
        setStyle(buttonDiv, { background: `${this.card.color}` });
        // 事件监听
        this.disposes.push(addEventListener(containerDiv, 'mouseover', () => {
            setStyle(containerDiv, this.getStyle(true));
        }));
        this.disposes.push(addEventListener(containerDiv, 'mouseout', () => {
            containerDiv.style.cssText = '';
        }));
        this.disposes.push(addEventListener(containerDiv, 'click', () => this.clickFunc && this.clickFunc()));
        // 构建结构
        containerDiv.append(titleP, imageDiv, descP, buttonDiv);
        titleP.append(titleSpan);
        descP.append(descSpan);
        buttonDiv.append(buttonSpan, buttonSvg);
        this.el = containerDiv;
        return containerDiv;
    }
}
AnalyticsMarketingCardService.componentName = 'AnalyticsMarketingCard';
//# sourceMappingURL=analytics.js.map